export const COLOR_HEX_MAP: Record<string, string> = {
  black: "#000000",
  white: "#ffffff",
  gray: "#6b7280",
  grey: "#6b7280",
  silver: "#c0c0c0",
  red: "#dc2626",
  pink: "#ec4899",
  orange: "#f97316",
  yellow: "#eab308",
  green: "#16a34a",
  emerald: "#059669",
  teal: "#0d9488",
  blue: "#2563eb",
  navy: "#1e3a8a",
  purple: "#9333ea",
  brown: "#92400e",
  tan: "#d2b48c",
  beige: "#f5f5dc",
  cream: "#fffdd0",
  gold: "#d4af37",
  multi: "conic-gradient(red, orange, yellow, green, blue, purple, red)",
};

export function hexForColor(color: string): string {
  return COLOR_HEX_MAP[color.toLowerCase()] ?? "#cbd5e1";
}
